// import "leaflet/dist/leaflet.css";
import L from "leaflet";
import "leaflet-providers";

import 'leaflet/dist/leaflet.css';

export default class Map {
  constructor(el) {
    this.el = el

    let map = L.map(el, {
      scrollWheelZoom: false,
      dragging: !L.Browser.mobile,
      tap: !L.Browser.mobile
    }).setView([
      el.dataset.mapLat,
      el.dataset.mapLng,
    ], el.dataset.mapZoom);

    // add Stamen Toner to map.
    L.tileLayer.provider('Stamen.Toner').addTo(map);

    var iconSettings = {
      mapIconUrl: '<svg viewBox="0 0 20 20"><path fill="{mapIconColor}" stroke="{mapIconStrokeColor}" stroke-width=".75" stroke-miterlimit="10" fill-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd"></path></svg>',
      mapIconColor: 'currentColor',
      mapIconStrokeColor: '#000',
      mapIconColorInnerCircle: '#fff',
      pinInnerCircleRadius:48
    };



    // icon normal state
    var divIcon = L.divIcon({
      className: "leaflet-data-marker",
      html: L.Util.template(iconSettings.mapIconUrl, iconSettings), //.replace('#','%23'),
      iconAnchor  : [24, 24],
      iconSize    : [48, 48],
      popupAnchor : [0, -24]
    });

    var marker = L.marker([el.dataset.mapLat, el.dataset.mapLng], {
      icon: divIcon,
    }).addTo(map);

  }
}
